import { actionCreator } from '@ardoq/rxbeach';
import { CssEntry } from '@ardoq/scope-data';

export type StyledEntityCss = [key: string, css: CssEntry[]];
export type ResetEntityCss = [key: string];
export type EntityCssUpdates = Array<StyledEntityCss | ResetEntityCss>;

export const addToStyleSheet = actionCreator<EntityCssUpdates>(
  '[modelCssManager] ADD_TO_STYLESHEET'
);

export const addStylesToStyleSheet = actionCreator<EntityCssUpdates[]>(
  '[modelCssManager] ADD_STYLES_TO_STYLESHEET'
);

export const clearStyles = actionCreator<string[]>(
  '[modelCssManager] CLEAR_STYLES'
);
